const DAYS_OF_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']

class DateUtils {
  static getSuffix(num) {
    switch(num) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  static longFormatDate(date) {
    if (date) {
      let day_of_week = DAYS_OF_WEEK[date.getDay()];
      let month = MONTHS[date.getMonth()];
      let day = date.getDate();
      let suffix = this.getSuffix(day);
      return day_of_week + ', ' + month + ' ' + date.getDate() + suffix + ', ' + date.getFullYear();
    } else {
      return '';
    }
  }
}

export default DateUtils;



// WEBPACK FOOTER //
// ./src/Utils/DateUtils.js